import React from 'react';

const AuthLayout = ({ children }) => {
  return (
    <main>{children}</main>
  );
};

export default AuthLayout;
